import { RootState } from "../store";

export function getCollapsed(state: RootState) {
	return state.MenuReducer.collapsed;
}
